import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

import { Tasks } from '../../../models/tasks';
import { DashboardService } from '@features/dashboard/services/dashboard.service';


@Component({
  selector: 'app-task-list',
  templateUrl: './task-list.component.html',
  styleUrls: ['./task-list.component.scss']
})
export class TaskListComponent implements OnInit {

  public taskOverview$!: Observable<Tasks>;

  constructor(private dashboardService: DashboardService) { }

  ngOnInit(): void {
    this.taskOverview$ = this.dashboardService.getTaskOverview();
  }

}
